export const ASSET_URLS = {
  CREATOR_SHOP_HOME: {
    /** https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=22853-99570&t=havlFtzdmTUoRecr-0 */
    CREATOR_SHOP_HOME_ADULT_CREATOR_PROFILE_19:
      'https://s3.marpple.co/files/u_2339721/2025/7/original/91d1d9adad992202553e762ecdee7a4ae652f7c01.png',
    /** https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=22853-99570&t=havlFtzdmTUoRecr-0 */
    CREATOR_SHOP_HOME_ADULT_CREATOR_PROFILE_18:
      'https://s3.marpple.co/files/u_2339721/2025/8/original/54ec0085d11f9960f70441f25058fcee53a013aa1.png',
    CREATOR_SHOP_HOME_RANKING_TROPHY:
      'https://s3.marpple.co/files/u_2339721/2025/7/original/a0baff3768186df55cbceb62bc1ed4d840410c1d2.png',
  },
};
